import FuseDialog from '@fuse/core/FuseDialog';
import FuseMessage from '@fuse/core/FuseMessage';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import FuseSuspense from '@fuse/core/FuseSuspense';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from 'app/AppContext';
import SettingsPanel from 'app/fuse-layouts/shared-components/SettingsPanel';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import FooterLayout1 from './components/FooterLayout1';
import LeftSideLayout1 from './components/LeftSideLayout1';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import RightSideLayout1 from './components/RightSideLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';

const useStyles = makeStyles((theme) => ({
	root: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		height: '100%',
		overflow: 'hidden',
		backgroundColor: theme.palette.background.default,
		color: theme.palette.text.primary,
		'&.boxed': {
			maxWidth: 1280,
			margin: '0 auto',
			boxShadow: theme.shadows[3],
		},
		'&.scroll-body': {
			'& $wrapper': {
				height: 'auto',
				flex: '0 0 auto',
				overflow: 'auto',
			},
			'& $contentWrapper': {},
			'& $content': {},
		},
		'&.scroll-content': {
			'& $wrapper': {},
			'& $contentWrapper': {},
			'& $content': {},
		},
		'& .navigation': {
			'& .list-subheader-text, & .list-item-text, & .item-badge, & .arrow-icon': {
				transition: theme.transitions.create('opacity', {
					duration: theme.transitions.duration.shortest,
					easing: theme.transitions.easing.easeInOut,
				}),
			},
		},
	},
	wrapper: {
		display: 'flex',
		position: 'fixed',
		width: '100%',
		height: '100%',
		flex: '1 1 auto',
	},
	contentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		zIndex: 3,
		overflow: 'auto',
		flex: '1 1 auto',
		background: 'linear-gradient(90deg, rgba(244,249,255,1) 0%, rgba(208,226,244,1) 100%)',
	},
	content: {
		position: 'relative',
		display: 'flex',
		overflow: 'auto',
		flex: '1 1 auto',
		flexDirection: 'column',
		width: '100%',
		'-webkit-overflow-scrolling': 'touch',
		zIndex: 2,
	},
}));

const Layout1 = (props) => {
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const classes = useStyles(props);

	switch (config.scroll) {
		case 'body': {
			return (
				<div id="fuse-layout" className={clsx(classes.root, config.mode, `scroll-${config.scroll}`)}>
					{config.leftSidePanel.display ? <LeftSideLayout1 /> : null}

					<div className="flex flex-1 flex-col overflow-hidden relative">
						{config.toolbar.display &&
						config.toolbar.style === 'fixed' &&
						config.toolbar.position === 'above' ? (
							<ToolbarLayout1 />
						) : null}

						{/* <FuseScrollbars className="overflow-auto" scrollToTopOnRouteChange> */}
							{config.toolbar.display &&
							config.toolbar.style !== 'fixed' &&
							config.toolbar.position === 'above' ? (
								<ToolbarLayout1 />
							) : null}

							<div className={`${classes.wrapper}`}>
								{config.navbar.display && config.navbar.position === 'left' ? (
									<NavbarWrapperLayout1 />
								) : null}

								<div className={classes.contentWrapper}>
									{config.toolbar.display && config.toolbar.position === 'below' ? (
										<ToolbarLayout1 />
									) : null}

									<div className={classes.content}>
										<FuseDialog />

										<FuseSuspense>
											<Outlet />
										</FuseSuspense>

										{props.children}
									</div>

									{config.footer.display && config.footer.position === 'below' ? (
										<FooterLayout1 />
									) : null}

									<SettingsPanel />
								</div>

								{config.navbar.display && config.navbar.position === 'right' ? (
									<NavbarWrapperLayout1 />
								) : null}
							</div>

							{config.footer.display &&
							config.footer.style !== 'fixed' &&
							config.footer.position === 'above' ? (
								<FooterLayout1 />
							) : null}
						{/* </FuseScrollbars> */}

						{config.footer.display &&
						config.footer.style === 'fixed' &&
						config.footer.position === 'above' ? (
							<FooterLayout1 />
						) : null}
					</div>

					{config.rightSidePanel.display ? <RightSideLayout1 /> : null}

					<FuseMessage />
				</div>
			);
		}
		case 'content':
		default: {
			return (
				<div id="fuse-layout" className={clsx(classes.root, config.mode, `scroll-${config.scroll}`)}>
					{config.leftSidePanel.display ? <LeftSideLayout1 /> : null}

					<div className="flex flex-1 flex-col overflow-hidden relative">
						{config.toolbar.display && config.toolbar.position === 'above' ? <ToolbarLayout1 /> : null}

						<div
							className={classes.wrapper}
							style={{
								marginTop: `${config.toolbar.display ? '81px' : 0}`,
							}}
						>
							{config.navbar.display && config.navbar.position === 'left' ? (
								<NavbarWrapperLayout1 />
							) : null}

							<div className={classes.contentWrapper}>
								{config.toolbar.display &&
								config.toolbar.position === 'below' &&
								config.toolbar.style === 'fixed' ? (
									<ToolbarLayout1 />
								) : null}

								<FuseDialog />

								<FuseSuspense>
									<Outlet />
								</FuseSuspense>
							</div>

							{config.navbar.display && config.navbar.position === 'right' ? (
								<NavbarWrapperLayout1 />
							) : null}
						</div>
					</div>

					{/* {config.rightSidePanel.display ? <RightSideLayout1 /> : null} */}

					<FuseMessage />
				</div>
			);
		}
	}
};

export default Layout1;
